import { ApiBind, Common } from './common.model';


export class PlatformOSGroup extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'platform_name' })
  platformName: string;

  @ApiBind({ column: 'media_type' })
  mediaType: number;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'os_group_id' })
  osGroupId: number;

  @ApiBind({ column: 'os_group_name' })
  osGroupName: string;

  @ApiBind({ column: 'memo' })
  memo: string;

  @ApiBind({ column: 'delivery_type' })
  deliveryType: number;

  @ApiBind({ column: 'sort' })
  sort: number;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;
}
